import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import BrowserDetection from 'react-browser-detection'

import headerPhoneVideo from '../../../images/headerphone-looped.mp4'
import { desktop, mobile } from '../../utils/media-query'

const EdgeVideo = styled.div`
    ${desktop.css`
        position: absolute;
        right: 0;
        height: 620px;
        z-index: 1;

        video {
            clip-path: url(#clipping);
            height: 620px;
        }

        svg {
            width: 730px;
            height: 100%;
        }
    `}

    ${mobile.css`
        opacity: 0.2;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;

        svg {
            width: 730px;
            height: 100%;
        }

        video {
            height: 80%;
            clip-path: url(#clipping);
        }
    `}
`

const Video = styled.div`
    ${desktop.css`
        position: absolute;
        right: 0;
        height: 620px;
        clip-path: polygon(45% -2%, 95% 7%, 54% 100%, 3% 93%);
        z-index: 1;
        transform: translate(55px, 20px);
        video {
            height: 620px;
        }
    `}
    ${mobile.css`
        opacity: 0.2;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        video {
            height: 80%;
            transform: translate(6%,-12%)
        }
    `}
`

const HeaderVideo = () => {
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    /*
        Edge and IE do not support a full css solution for video clipping so must default to a svg version
    */
    const browserDetectionHandler = {
        edge: () => (
            <EdgeVideo>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <clipPath id="clipping" clipPathUnits="objectBoundingBox">
                            <polygon points="0.45, -0.02, 0.99, 0.06, 0.56, 1, 0.03, 0.93" />
                        </clipPath>
                    </defs>

                    <foreignObject width="100%" height="100%" clipPath="url(#clipping)">
                        <video autoPlay loop muted playsInline>
                            <source src={headerPhoneVideo} type="video/mp4" />
                        </video>
                    </foreignObject>
                </svg>
            </EdgeVideo>
        ),
        default: () => (
            <Video>
                <video autoPlay loop muted playsInline>
                    <source src={headerPhoneVideo} type="video/mp4" />
                </video>
            </Video>
        ),
    }

    return mounted ? <BrowserDetection>{browserDetectionHandler}</BrowserDetection> : null
}

export default HeaderVideo
